/* eslint-disable no-console */

function normalizeBasePath(basePath = '/') {
  if (!basePath || basePath === '/') {
    return '/';
  }

  const withLeadingSlash = basePath.startsWith('/') ? basePath : `/${basePath}`;
  return withLeadingSlash.endsWith('/') ? withLeadingSlash : `${withLeadingSlash}/`;
}

export function parseTicketPath(pathname, basePath = '/') {
  const normalizedBasePath = normalizeBasePath(basePath);
  const pathSegments = pathname.split('/').filter(Boolean);
  const baseSegments = normalizedBasePath.split('/').filter(Boolean);

  let appPathSegments = pathSegments;
  const startsWithBase = baseSegments.every((segment, index) => pathSegments[index] === segment);
  if (startsWithBase) {
    appPathSegments = pathSegments.slice(baseSegments.length);
  }

  return {
    ticketID: appPathSegments[0],
    token: appPathSegments[1],
  };
}

/* REPLACE MANIFEST WITH THE TICKETID FIRST */
const { ticketID, token } = parseTicketPath(window.location.pathname, process.env.BASE_URL);
if (ticketID && token) {
  const manifest = document.createElement('link')
  const urlParameter = "?domain=" + location.origin;
  manifest.setAttribute('rel', 'manifest');
  manifest.setAttribute('href', "https://api.ticketpark.ch/pep/manifest/" + ticketID + "/" + token + urlParameter);

  document.head.appendChild(manifest)
}

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
      console.log('Service worker is ready.')
      const event = new Event('sw-register');
      window.dispatchEvent(event)
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
